import {useState} from 'react';

import {getSafely} from 'shared/web';

import {UpdateFiltersFunction, useFilters} from '../components/FiltersContext/FiltersContext';
import {DEFAULT_FILTERS, FiltersType} from '../types/FiltersType';
import {hasSomeFilters} from '../utils/hasSomeFilters';

export function useFilterDraft() {
  const applied = useFilters();
  const [draft, setDraft] = useState<FiltersType | null>(null);
  const filters = draft ?? applied.filters;
  const onUpdateFilters: UpdateFiltersFunction = (key, value) => {
    if (draft === null) {
      applied.onUpdateFilters(key, value);
      return;
    }
    setDraft((current) => {
      const previous = current ?? applied.filters;
      return {
        ...previous,
        [key]: typeof value === 'function' ? value(getSafely(previous, key)) : value,
      };
    });
  };

  return {
    context: {
      filters,
      hasFilters: hasSomeFilters(filters),
      onChange: draft === null ? applied.onChange : setDraft,
      onUpdateFilters,
      onClearFilters: draft === null ? applied.onClearFilters : () => setDraft(DEFAULT_FILTERS),
    },
    begin: () => setDraft(applied.filters),
    cancel: () => setDraft(null),
    apply: () => {
      applied.onChange(filters);
      setDraft(null);
    },
  };
}
